import React, { Fragment } from "react";
import * as MUI from "@mui/material";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import { Link } from "react-router-dom";
export default function TermsAndConditionsSlo() {
  const { mode } = React.useContext(ThemeContext);
  return (
    <Fragment>
      <MUI.Typography variant="h3">Pogoji uporabe</MUI.Typography>
      <MUI.Divider />
      <Fragment>
        <MUI.Stack spacing={4}>
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h4">
              Politika varstva podatkov
            </MUI.Typography>
            <MUI.Typography variant="h5">
              {String("Uvod").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Zavezani smo k varstvu zasebnosti in varnosti vaših osebnih
              podatkov v skladu s Splošno uredbo o varstvu podatkov (GDPR) (EU
              Uredba 2016/679). Ta politika pojasnjuje, kako zbiramo,
              obdelujemo in shranjujemo vaše osebne podatke pri uporabi
              naše platforme za upravljanje veterinarskih klinik. Naš cilj je
              zagotoviti preglednost in zaupanje ob upoštevanju zakonodaje o
              varstvu podatkov ter odgovorno in varno ravnanje z vašimi podatki.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Varnostni ukrepi").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Uporabljamo varnostne ukrepe industrijskega standarda za zaščito
              vaših podatkov, vključno s šifriranjem, rednimi varnostnimi
              pregledi in strogimi kontrolami dostopa, da preprečimo
              nepooblaščen dostop.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("DOSTOP DO SPLETNEGA MESTA").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Ko obiščete naše spletno mesto, bo vaš brskalnik posredoval
              določene podatke na naš spletni strežnik. Prenos podatkov se
              izvede iz tehničnih razlogov, da vam lahko zagotovimo zahtevane
              informacije. Za lažji dostop do spletnega mesta se zbirajo,
              začasno shranjujejo in uporabljajo naslednji podatki:
            </MUI.Typography>
            <MUI.List sx={{ listStyleType: "disc" }}>
              <MUI.ListItem sx={{ display: "list-item" }}>
                IP naslov
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list-item" }}>
                Datum in čas dostopa
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list-item" }}>
                Razlika v časovnem pasu glede na Greenwich Mean Time (GMT)
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Vsebina zahteve (specifična stran)
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Status dostopa / koda stanja HTTP
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Količina prenesenih podatkov
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Spletno mesto, ki zahteva dostop
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Brskalnik, jezikovne nastavitve, različica brskalnika,
                operacijskega sistema in zaslona
              </MUI.ListItem>
            </MUI.List>
            <MUI.Typography>
              Poleg tega te podatke za omejeno obdobje shranjujemo z namenom
              zaščite naših legitimnih interesov, da bi lahko sprožili sledenje
              osebnih podatkov v primeru nepooblaščenega dostopa do naših
              strežnikov ali poskusa le-tega (člen 6(1)(f) Splošne uredbe o
              varstvu podatkov).
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Katere podatke zbiramo").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Za zagotavljanje naših storitev zbiramo naslednje vrste
                podatkov:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Osebni podatki: Ime, telefonska številka, e-poštni naslov in
                  drugi kontaktni podatki.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Podatki o hišnih ljubljenčkih: Ime hišnega ljubljenčka,
                  vrsta, pasma, starost in zdravstveni podatki (npr. datumi
                  cepljenj, zdravljenja).
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Podatki o računu: Uporabniška imena, gesla in nastavitve,
                  povezane z vašim računom.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Ti podatki nam omogočajo zagotavljanje storitev, kot so
                naročanje terminov, upravljanje zdravstvenih kartotek hišnih
                ljubljenčkov in učinkovita komunikacija med lastniki
                ljubljenčkov in veterinarskim osebjem.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Kako uporabljamo vaše podatke").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Vaše podatke obdelujemo za naslednje namene:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Omogočanje naročanja terminov in rezervacij.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Shranjevanje in upravljanje zdravstvenih kartotek hišnih
                  ljubljenčkov za neprekinjeno zdravljenje.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Zagotavljanje natančne komunikacije med lastniki hišnih
                  ljubljenčkov in veterinarskim osebjem.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Podpora internim orodjem za upravljanje poslovanja klinik.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Vaše podatke obdelujemo izključno za namene zagotavljanja in
                izboljševanja naših storitev.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Kdo ima dostop do vaših podatkov").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Dostop do vaših osebnih podatkov je omejen na pooblaščeno
                osebje:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Zaposleni v veterinarskih klinikah: Zaposleni v kliniki, ki
                  jo izberete za zdravljenje vašega hišnega ljubljenčka. V
                  primeru menjave klinike ima nova klinika dostop le do novih
                  podatkov, medtem ko prejšnja klinika ohrani zgodovinske
                  podatke o opravljenih storitvah.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Skrbniki aplikacije: Pooblaščeni zaposleni v našem podjetju,
                  odgovorni za vzdrževanje in izboljšanje platforme.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Vaših osebnih podatkov ne delimo s tretjimi stranmi, razen če
                to zahteva zakon ali če integriramo zunanje storitve (npr.
                sisteme POS) z vašim soglasjem.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Vaše pravice po GDPR").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                V zvezi s svojimi podatki imate naslednje pravice:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Dostop: Pregled vseh osebnih podatkov, ki jih hranimo o vas.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Popravek: Popravek netočnih podatkov.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Izbris: Zahteva za izbris vaših podatkov, razen zakonsko
                  obveznih zapisov.{" "}
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Prenosljivost podatkov: Zahteva za kopijo vaših podatkov v
                  strukturirani, strojno berljivi obliki.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Umik soglasja: Umik soglasja za obdelavo podatkov kadar koli.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Za uveljavljanje teh pravic nas kontaktirajte na:{" "}
                <Link
                  color="inherit"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = `mailto:${"info@kilobyte.hr"}`;
                  }}
                >
                  info@kilobyte.hr
                </Link>
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Obdobje hrambe podatkov").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Vaše podatke hranimo, dokler je vaš račun aktiven. Če izbrišete
                svoj račun, izbrišemo vse povezane osebne podatke, razen če je
                zakonsko ali operativno potrebno ohraniti določene podatke. Na
                primer, zdravljenja, povezana z vašim hišnim ljubljenčkom,
                ostanejo vidna kliniki, ki je opravila storitev.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("UPORABA PIŠKOTKOV").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                CENTER ZA VARSTVO PRI DELU uporablja orodja za analizo uporabe
                spletnega portala CENTER ZA VARSTVO PRI DELU, s katerimi lahko
                zbiramo določene informacije o vas ter s tem pridobivamo
                spoznanja o potrebah naših obiskovalcev in/ali uporabnikov z
                namenom izboljšanja kakovosti naše ponudbe. V ta namen se
                uporabljajo tudi tako imenovani piškotki in nekatera druga
                orodja.
              </MUI.Typography>
              <MUI.Typography>
                Uporabnik in/ali obiskovalec lahko prek ustreznih nastavitev na
                svojem računalniku, z nastavitvami brskalnika, ki ga uporablja,
                zavrne ali izbriše piškotke. Vendar pa to lahko povzroči, da
                nekaterih funkcij spletnega portala CENTER ZA VARSTVO PRI DELU
                ne bo mogoče več v celoti uporabljati.
              </MUI.Typography>
              <MUI.Typography>
                Navedena orodja zbirajo in shranjujejo nekatere tehnične
                podatke, vključno z IP naslovom uporabnika in/ali obiskovalca.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Storitve tretjih strank in globalna uporaba").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Čeprav trenutno poslujemo znotraj EU, naša platforma temelji na
              oblaku in podatki se lahko obdelujejo na strežnikih v drugih
              državah. Zagotavljamo, da so vsi mednarodni prenosi podatkov
              skladni s standardi GDPR. Če integriramo storitve tretjih strank
              (npr. POS ali analitiko), zagotovimo, da so ti ponudniki storitev
              skladni z GDPR in izpolnjujejo naše stroge standarde zasebnosti.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("POVEZAVE NA DRUGA SPLETNA MESTA").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              To spletno mesto lahko vsebuje povezave na druga spletna mesta,
              ki jih upravljajo druge organizacije z lastnimi posebnimi pravili
              zasebnosti. Priporočamo, da se seznanite z njihovimi pogoji
              uporabe in pravili zasebnosti, preden jim posredujete kakršne koli
              osebne podatke, saj CENTER ZA VARSTVO PRI DELU ne prevzema
              odgovornosti za ta spletna mesta ali organizacije, ki jih
              upravljajo.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Posodobitve te politike").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              To politiko lahko občasno posodobimo, da odražamo spremembe
              zakonskih zahtev ali naših storitev. O pomembnih spremembah bomo
              obvestili po e-pošti ali v aplikaciji, preden začnejo veljati.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Kontaktni podatki".toUpperCase())}
            </MUI.Typography>
            <MUI.Typography>
              Če imate vprašanja, pomisleke ali pritožbe v zvezi s to politiko,
              nas lahko kontaktirate na: E-pošta:{" "}
              <Link
                color="inherit"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = `mailto:${"info@kilobyte.hr"}`;
                }}
              >
                info@kilobyte.hr
              </Link>
            </MUI.Typography>
          </MUI.Stack>
        </MUI.Stack>
      </Fragment>
    </Fragment>
  );
}